import _ from "lodash";
import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";
import {
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  PLANNER_ELEMENT_NESTED_CHECKLIST,
} from "Constants/stringConstants";

export const FILTER_TYPES = {
  SEARCH: "SEARCH",
  STATUS: "STATUS",
  SHOW: "SHOW",
  GRADES: "GRADES",
  SUBJECT_AREAS: "SUBJECT_AREAS",
  TAGS: "TAGS",
  SUBJECTS: "SUBJECTS",
  SUBJECT_GROUP: "SUBJECT_GROUP",
  HIDE_LOCKED: "HIDE_LOCKED",
};

export const STATUS_TYPES = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  ALL: "ALL",
};

export const COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_FILTERS_QUERY = {
  [DATA_GRID_COLUMN_TYPES.GRADE_LEVELS]: "shouldSkipGrades",
  [DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS]: "shouldSkipSubjects",
  [DATA_GRID_COLUMN_TYPES.TAGS]: "shouldSkipGenericTags",
  [DATA_GRID_COLUMN_TYPES.SUBJECT_GROUP]: "shouldSkipSubjectGroups",
};

export const COLUMN_TYPE_MAP_TO_SKIP_FLAGS_FOR_TAGGED_IN_QUERY = {
  [DATA_GRID_COLUMN_TYPES.TAGGED_IN_ASSIGNMENTS]: "shouldSkipAssessment",
  [DATA_GRID_COLUMN_TYPES.TAGGED_IN_PORTFOLIO]: "shouldSkipPortfolio",
  [DATA_GRID_COLUMN_TYPES.TAGGED_IN_UNITS]: "shouldSkipUnitPlan",
};

export const ACTION_TYPES = {
  OPEN_TAGGED_IN_ASSIGNMENTS_MODAL: "OPEN_TAGGED_IN_ASSIGNMENTS_MODAL",
  OPEN_TAGGED_IN_PORTFOLIO_MODAL: "OPEN_TAGGED_IN_PORTFOLIO_MODAL",
  OPEN_TAGGED_IN_UNITS_MODAL: "OPEN_TAGGED_IN_UNITS_MODAL",
};

export const FILTERS_TO_SHOW = [
  FILTER_TYPES.GRADES,
  FILTER_TYPES.SUBJECT_AREAS,
  FILTER_TYPES.TAGS,
  FILTER_TYPES.STATUS,
  FILTER_TYPES.SHOW,
  FILTER_TYPES.SUBJECT_GROUP,
];

export const SHOW_FILTER_TYPES = {
  ALL: "ALL",
  POWER_STANDARD: "POWER_STANDARD",
};

export const FILTER_TYPE_TO_VARIABLE_NAME = {
  [FILTER_TYPES.SEARCH]: "searchText",
  [FILTER_TYPES.STATUS]: "archivalState",
  [FILTER_TYPES.SHOW]: "isPowerStandard",
  [FILTER_TYPES.GRADES]: "grades",
  [FILTER_TYPES.SUBJECT_AREAS]: "subjects",
  [FILTER_TYPES.SUBJECT_GROUP]: "subjectGroups",
  [FILTER_TYPES.TAGS]: "tags",
  [FILTER_TYPES.HIDE_LOCKED]: "hideLockedStandards",
};

export const VARIABLE_NAME_TO_FILTER_TYPE = _.invert(
  FILTER_TYPE_TO_VARIABLE_NAME
);

export const DEFAULT_FILTERS = {
  [FILTER_TYPES.SEARCH]: "",
  [FILTER_TYPES.STATUS]: STATUS_TYPES.ACTIVE,
  [FILTER_TYPES.GRADES]: [],
  [FILTER_TYPES.SUBJECT_AREAS]: [],
  [FILTER_TYPES.TAGS]: [],
  [FILTER_TYPES.SHOW]: SHOW_FILTER_TYPES.ALL,
};

export const SHOW_FILTER_OPTIONS = t => [
  {
    id: SHOW_FILTER_TYPES.ALL,
    label: t("scopeAndSequence:all_standards"),
  },
  {
    id: SHOW_FILTER_TYPES.POWER_STANDARD,
    label: t("scopeAndSequence:power_standards_only"),
  },
];

export const STATUS_OPTIONS = t => [
  {
    id: STATUS_TYPES.ALL,
    label: t("common:all"),
  },
  {
    id: STATUS_TYPES.ACTIVE,
    label: t("common:active"),
  },
  {
    id: STATUS_TYPES.ARCHIVED,
    label: t("common:archived"),
  },
];

export const FILTERS_TO_DATA_GRID_COLUMN_ID = {
  [FILTER_TYPES.GRADES]: DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
  [FILTER_TYPES.SUBJECT_AREAS]: DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  [FILTER_TYPES.SHOW]: DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  [FILTER_TYPES.TAGS]: DATA_GRID_COLUMN_TYPES.TAGS,
  [FILTER_TYPES.SUBJECT_GROUP]: DATA_GRID_COLUMN_TYPES.SUBJECT_GROUP,
};

export const DEFAULT_HIDDEN_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.WEIGHT,
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];

export const PARENT_TAGGING_SUPPORTED_PLANNER_ELEMENT_TYPES = new Set([
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_PYP_ATL,
  PLANNER_ELEMENT_NESTED_CHECKLIST,
]);
